import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { CheckboxStyles } from './checkbox-styles';

let uid = 0;
@Component({
  selector: 'pg-checkbox, grit-checkbox',
  templateUrl: './pg-checkbox.component.html',
  styleUrls: ['./pg-checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'pgCheckbox, gritCheckbox',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: PgCheckboxComponent,
      multi: true,
    },
  ],
})
export class PgCheckboxComponent implements OnInit, ControlValueAccessor {
  @ViewChild('checkboxElement', { static: true }) checkboxElement: ElementRef;

  @HostBinding('class.grit-check-box')
  @HostBinding('class.pg-check-box')
  readonly _classPgCheckBox = true;

  // TODO: do we care about indeterminate state.
  @Input('checked')
  @HostBinding('class.checked')
  checked;
  @Output()
  checkedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostBinding('class.is-focused')
  _isFocused = false;

  _colorOverride;

  @Input('alignment')
  alignment = 'LEFT';

  @Input('disabled')
  @HostBinding('class.disabled')
  disabled = false;

  @Input('htmlOverride')
  htmlOverride: string;

  @HostBinding('style.flex-direction')
  get flexDirection() {
    if (!this.alignment) {
      return 'row';
    }
    return this.alignment.toUpperCase() === 'LEFT' ? 'row' : 'row-reverse';
  }

  @HostBinding('style.justify-content')
  get flexAlignment() {
    if (!this.alignment) {
      return 'flex-start';
    }
    return this.alignment.toUpperCase() === 'LEFT' ? 'flex-start' : 'flex-end';
  }

  @Input() styleOverrides: CheckboxStyles;

  @Input('id')
  id;

  constructor(private renderer: Renderer2) {}

  ngOnInit() {
    if (!this.id) {
      this.id = 'check-' + uid++;
    }
  }

  onFocus() {
    this._isFocused = true;
  }

  onBlur() {
    this._isFocused = false;
    this.renderer.removeClass(this.checkboxElement.nativeElement, 'clicked');
  }

  onClick() {
    this.writeValue(!!!this.checked);
    this.checkedChange.emit(this.checked);
  }

  onMouseDown() {
    this.renderer.addClass(this.checkboxElement.nativeElement, 'clicked');
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.keyCode === 32 && !this.disabled) {
      this.onClick();
    }
  }

  getId() {
    return this.id + '-label';
  }

  onChange = _ => {};
  onTouch = () => {};

  writeValue(obj: any): void {
    this.checked = obj;
    this.onTouch();
    this.onChange(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
